import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const PageLayout = ({ children }: Props) => {
  return <main>{children}</main>;
};

export default PageLayout;
